<template>
  <page-container>
    <template v-slot:page-fixed-header>
      <v-col cols="12" sm="10" md="10" class="pl-2" v-if="isDataLoading">
        <v-skeleton-loader
          type="heading"
          class="text-h3 font-weight-bold full-width"
        ></v-skeleton-loader>
      </v-col>
      <span v-else class="text-h5 font-weight-bold ml-3 full-width page-header">
        <span v-if="profileData.firstName"
          >{{ profileData.firstName || "First name" }}
          {{ profileData.lastName || "Last name" }}</span
        >
        <span v-else>
          {{ profileData.display_email }}
        </span></span
      >
      <v-spacer></v-spacer>
      <v-tooltip bottom v-if="$security.checkUserAccess('UpdatePeople')">
        <template v-slot:activator="{ on, attrs }">
          <a-btn
            v-bind="attrs"
            v-on="on"
            :class="
              !isDirty || !isPhotoUploading || isDescriptionWithImg
                ? 'mr-2 disabled-button'
                : 'mr-2 primaryDark'
            "
            @click.stop="updatePeopleProfile"
            :disabled="!isDirty || !isPhotoUploading || isDescriptionWithImg"
            dark
            v-if="$security.checkUserAccess('UpdatePeople')"
          >
            <v-icon left>mdi-content-save</v-icon>{{ $t("btnSave") }}
          </a-btn>
        </template>
        <span>{{ $t("btnSave") }}</span>
      </v-tooltip>
      <CloseIcon @click="onclose()" :right="true" />
    </template>
    <template v-slot:page-content>
      <v-card flat tile style="width: 100%">
        <v-card-text>
          <v-row>
            <v-col cols="12" sm="12" md="12" class="pa-0" v-if="isDataLoading">
              <v-card flat>
                <v-card-text>
                  <v-container>
                    <v-skeleton-loader
                      type="image,list-item-two-line, list-item-two-line, article, list-item"
                    ></v-skeleton-loader>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" sm="12" md="12" class="pa-0" v-else>
              <v-card flat>
                <v-card-text>
                  <v-container>
                    <v-form ref="form" v-model="valid" lazy-validation>
                      <v-row>
                        <v-col cols="12" sm="6" md="2">
                          <v-card flat width="210">
                            <profile-photo
                              @uploading="photoUploading"
                              v-model="profileData.profilePhoto"
                              :ispermitted="
                                $security.checkUserAccess('UpdatePeople')
                              "
                              section="people"
                            ></profile-photo>
                          </v-card>
                        </v-col>
                        <v-col cols="12" sm="7" md="10">
                          <v-row>
                            <v-col cols="12" sm="12" md="4">
                              <v-text-field
                                :disabled="!isPhotoUploading"
                                dense
                                filled
                                class="textField"
                                v-model.trim="profileData.title"
                                :label="`${$t('people.lblTitle')}*`"
                                :rules="titleRules"
                                counter="200"
                                prepend-icon="mdi-label"
                                hide-details="auto"
                                required
                                auto-grow
                                :readonly="
                                  !$security.checkUserAccess('UpdatePeople')
                                "
                              />
                            </v-col>
                            <v-col cols="12" sm="12" md="4">
                              <v-text-field
                                :disabled="!isPhotoUploading"
                                dense
                                class="textField"
                                filled
                                v-model.trim="profileData.display_email"
                                prepend-icon="mdi-email"
                                :label="`${$t('people.lblEmail')} *`"
                                readonly
                                v-if="
                                  contactEmails && contactEmails.length <= 1
                                "
                              ></v-text-field>
                              <v-select
                                :disabled="!isPhotoUploading"
                                v-else
                                class="selectField"
                                v-model="profileData.display_email"
                                dense
                                filled
                                :label="`${$t('people.lblEmail')} *`"
                                :items="contactEmails"
                                :menu-props="{ bottom: true, offsetY: true }"
                                :readonly="
                                  !$security.checkUserAccess('UpdatePeople')
                                "
                              ></v-select>
                            </v-col>
                            <v-col cols="12" sm="12" md="4">
                              <v-text-field
                                :disabled="!isPhotoUploading"
                                dense
                                class="textField"
                                filled
                                v-model.trim="profileData.linkedin"
                                prepend-icon="mdi-web"
                                :rules="fieldRequired"
                                counter="100"
                                required
                                :label="$t('people.lblSocialId')"
                                :readonly="
                                  !$security.checkUserAccess('UpdatePeople')
                                "
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="12" md="4">
                              <v-text-field
                                :disabled="!isPhotoUploading"
                                dense
                                class="textField"
                                filled
                                v-model.trim="profileData.personalityType"
                                prepend-icon="  mdi-tag-faces"
                                :label="$t('people.lblPersonality')"
                                :rules="fieldRequired"
                                counter="100"
                                required
                                :readonly="
                                  !$security.checkUserAccess('UpdatePeople')
                                "
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="12" md="8">
                              <a-autocomplete
                                :disabled="!isPhotoUploading"
                                id="autocomplete-skills"
                                filled
                                dense
                                v-model="profileData.skills"
                                :items="skillList"
                                item-text="name"
                                item-value="name"
                                chips
                                :label="$t('people.lblSkills')"
                                prepend-icon="mdi-head-cog"
                                :rules="rules"
                                multiple
                                required
                                :search-input.sync="search"
                                @change="changeSkills"
                                :readonly="
                                  !$security.checkUserAccess('UpdatePeople')
                                "
                                :no-data-text="$t('noData')"
                              >
                                <template v-slot:selection="data">
                                  <a-chip
                                    v-bind="data.attrs"
                                    outlined
                                    class="pl-1 pr-1 mb-1 low"
                                    label
                                    small
                                    :input-value="data.selected"
                                    color="secondary darken-3"
                                    :close="
                                      $security.checkUserAccess('UpdatePeople')
                                    "
                                    dark
                                    @click:close="
                                      $security.checkUserAccess('UpdatePeople')
                                        ? remove(data.item)
                                        : ''
                                    "
                                    >{{ data.item.name }}</a-chip
                                  >
                                  <!-- @click:close="remove(data.item)" -->
                                </template>
                              </a-autocomplete>
                            </v-col>
                          </v-row>
                          <!--  <ejs-inplaceeditor
                    id="inplace_editor"
                    type="Text"
                    mode="Inline"
                    v-model="profileData.firstName"
                    :model="textModel"
                  >
                  </ejs-inplaceeditor> -->
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="12" md="6">
                          <people-history
                            v-model="histories"
                            :isPhotoUploading="isPhotoUploading"
                          ></people-history>
                        </v-col>
                        <v-col cols="12" sm="12" md="6">
                          <v-card height="100%">
                            <v-toolbar
                              flat
                              tile
                              dark
                              color="primaryDark"
                              height="40px"
                            >
                              {{ $t("people.lblOtherInfo") }}</v-toolbar
                            >
                            <v-card-text>
                              <InlineEditableRichText
                                v-model.trim="otherInformation"
                                :isEdit="
                                  $security.checkUserAccess('UpdatePeople')
                                "
                                :isPhotoUploading="isPhotoUploading"
                                @descriptionWithImg="otherInfoDescription"
                              ></InlineEditableRichText>
                            </v-card-text>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <tenant-switch-dialog ref="refSwitchDialog"></tenant-switch-dialog>
      <message-sheet
        :showMessage="displayMessage"
        :message="message"
        :messageType="messageType"
        @close="displayMessage = false"
      ></message-sheet>
      <prevent-navigation
        :prevent="isDescriptionWithImg ? false : isDirty"
        @save="saveOnLeave"
        @discard="$event.next()"
        @cancel="$event.next(false)"
      >
      </prevent-navigation>
      <confirm-dialog ref="confirm" />
    </template>
  </page-container>
</template>

<script>
import Vue from "vue";
import { mapActions, mapState, mapGetters } from "vuex";
import InlineEditableRichText from "@/components/people/InlineEditableRichText.vue";
import { InPlaceEditorPlugin, Rte } from "@syncfusion/ej2-vue-inplace-editor";
import PeopleHistory from "./PeopleHistory.vue";
import { getSkillColor, MAX_PROFILE_PHOTO_SIZE } from "../../utils/constant";
import MessageSheet from "../MessageSheet.vue";
import _ from "lodash";
import PreventNavigation from "@/components/PreventNavigation.vue";
import TenantSwitchDialog from "../TenantSwitchDialog.vue";
import SignalRMixin from "../../mixin/SignalRMixin";
import ConfirmDialog from "../ConfirmDialog.vue";
import { formatBytes, base64ToFile } from "../../utils/util";
import ProfilePhoto from "@/components/admin/ProfilePhoto.vue";
import {
  RichTextEditorPlugin,
  Toolbar,
  Link,
  Count,
  HtmlEditor,
  QuickToolbar,
  Table,
} from "@syncfusion/ej2-vue-richtexteditor";
Vue.use(InPlaceEditorPlugin);
export default {
  name: "ProfilePage",
  components: {
    PeopleHistory,
    InlineEditableRichText,
    MessageSheet,
    PreventNavigation,
    TenantSwitchDialog,
    ConfirmDialog,
    ProfilePhoto,
  },
  provide: {
    inplaceeditor: [Rte],
    richtexteditor: [Toolbar, Link, Count, HtmlEditor, QuickToolbar, Table],
  },
  mixins: [SignalRMixin],
  data() {
    return {
      isDescriptionWithImg: null,
      isPhotoUploading: true,
      isDataLoading: false,
      search: null,
      saveDisable: false,
      isPhotoSizeMax: false,
      maxProfileImgSize: MAX_PROFILE_PHOTO_SIZE,
      // routeTenantId: "",
      isPhotoUpdated: false,
      profileRef: {},
      originalProfile: {},
      description: "",
      historyData: [],
      displayMessage: false,
      message: this.$t("msgProfileSuccess"),
      messageType: "success",
      uploadFieldName: "photos",
      isPhotoUpload: true,
      valid: false,
      overlay: true,
      absolute: true,
      opacity: 0,
      rules: [],
      
      // skillList: [
      //   // "Management",
      //   // "Finance and Accounting",
      //   // "Governance",
      //   // "Global",
      //   // "Legal and Compliance",
      //   // "M & A and Finance",
      //   // "IT Business",
      //   // "Human Resources and Organization",
      // ],
      emailRules: [
        (v) => !!(v ? v.trim() : "") || this.$t("ruleEmailReq"),
        (v) => /.+@.+\..+/.test(v ? v.trim() : "") || this.$t("ruleEmailvalid"),
        (v) => !(v && this.checkUnique(v)) || this.$t("admin.msgEmailUnique"),
      ],
      titleRules: [
        (v) => !!(v ? v.trim() : "") || this.$t("ruleTitleReq"),
        (v) =>
          (v && v.length <= 200) || this.$t("ruleLimitVal", { number: 200 }),
      ],
      fieldRequired: [
        (v) =>
          (v || "").length <= 100 || this.$t("ruleLimitVal", { number: 100 }),
      ],
    };
  },
  computed: {
    ...mapState({
      peopleDetails: (state) => state.people.peopleDetails,
    }),
    ...mapGetters({
      peopleListApi: "people/getPeopleList",
      tenantSettingTypes: "tenant/tenantSettingTypes",
    }),
    LoaderText() {
      return this.$t("LoaderText");
    },
    skillList() {
      return this.tenantSettingTypes("skills");
    },
    userEmails() {
      const emails = [];
      this.peopleListApi.forEach((element) => {
        if (element.id != this.$route.params.id) {
          emails.push(element.display_email.toLowerCase());
        }
      });
      return emails;
    },
    contactEmails() {
      const emails = [];
      if (
        this.profileData.contactEmailIds &&
        this.profileData.contactEmailIds.length > 0
      ) {
        this.profileData.contactEmailIds.forEach((element) => {
          if (element) {
            emails.push(element);
          }
        });
      }
      return emails;
    },
    isDirty() {
      return (
        (JSON.stringify(this.originalProfile) !==
          JSON.stringify(this.profileData) ||
          this.isPhotoUpdated) &&
        this.$refs.form.validate()
      );
    },
    isFileUploaded() {
      return this.profileData.profilePhoto == "" ? false : true;
    },
    profileData: {
      get() {
        return this.profileRef;
      },
      set(value) {
        if (!value.linkedin) {
          value.linkedin = "";
        }
        this.profileRef = value;
        this.originalProfile = _.cloneDeep(value);
      },
    },
    histories: {
      get() {
        return this.historyData;
      },
      set(values) {
        this.historyData = values;
      },
    },
    selectedTenant() {
      return sessionStorage.getItem("tenantId");
    },
    otherInformation: {
      get() {
        return this.description;
      },
      set(values) {
        if (isOnlyHTMLTags(values)) {
          this.description = "";
        } else {
          this.description = values;
        }
      },
    },
    tenantId() {
      return sessionStorage.getItem("tenantId");
    },
  },
  watch: {
    historyData(values) {
      if (!this.profileData.history) {
        this.profileData.history = [];
      }
      this.profileData.history = values;
    },
    description(values) {
      if (!this.profileData.description) {
        this.profileData.description = "";
      }
      this.profileData.description = values;
    },
    peopleDetails(value) {
      value.description = value.description || "";
      value.history = value.history || [];
      this.profileData = _.cloneDeep(value);
    }
  },
  mounted,
  methods: {
    photoUploading(val) {
      this.isPhotoUploading = val;
    },
    changeSkills() {
      this.search = "";
    },
    ...mapActions({
      getPeopleById: "people/getPeopleById",
      updatePeople: "people/updatePeople",
      getPeopleList: "people/getPeopleList",
      getTenantConfigList: "tenant/getUpdatedTenantConfigList",
      getUpdatedUserList: "people/getUpdatedUserList",
    }),
    filesChange,
    wait,
    updatePeopleProfile,
    updatePeopleProfileOnLeave,
    getSkillColor,
    onclose,
    saveOnLeave,
    signalRInit,
    UpdatePeoplesData,
    formatBytes,
    waitOnMessage,
    filterKey,
    signalRConfigInit,
    otherInfoDescription(data) {
      this.isDescriptionWithImg = data;
    },
    onBlur: function (e) {
      this.$refs.rteObj.ej2Instances.toolbarSettings.enable = false;
    },
    onFocus: function (e) {
      this.$refs.rteObj.ej2Instances.toolbarSettings.enable = true;
    },
    remove(item) {
      //alert(JSON.stringify(this.profileData.skills.map(e=>e)))
      const index = this.profileData.skills.map((e) => e).indexOf(item.name);
      //alert(JSON.stringify(item))
      if (index >= 0) this.profileData.skills.splice(index, 1);
    },
    showMessageSheet(message, messageType) {
      this.displayMessage = true;
      this.message = message;
      this.messageType = messageType;
    },
    async clearPhoto() {
      if (
        await this.$refs.confirm.open(
          this.$t("lblConfirmRemoval"),
          this.$t("msgConfirmRemovalMsg"),
          { yesNoButtons: true }
        )
      ) {
        this.profileData.profilePhoto = "";
        this.$refs.inputUpload.value = null;
        this.isPhotoUpdated = true;
        this.isPhotoUpload = false;
        this.overlay = false;
      }
    },
    checkUnique(email) {
      return this.userEmails.includes(email.toLowerCase());
    },
  },
};

function isOnlyHTMLTags(inputString) {
  // Remove all HTML tags using a regular expression
  const strippedString = inputString.replace(/<\/?[^>]+(>|$)/g, "").trim();

  // Check if the stripped string is empty
  return strippedString === "";
}

function signalRInit(target) {
  this.signalConnection.on(target, async (message) => {
    const result = JSON.parse(message);
    if (result && this.$route.params.id) {
      const response = await this.getPeopleById(this.$route.params.id);
      if (!response.is_listed_in_people) {
        await this.$refs.confirm.open(
          this.$t("people.lblDeleteWarning"),
          this.$t("people.msgDeleteWarning"),
          { dialogIcon: "alert", noconfirm: true }
        );
        this.$router.push({ path: "/people" });
      } else {
        await this.getUpdatedUserList();
        this.UpdatePeoplesData();
      }
    }
  });

  if (this.signalConnection.connectionState.toLowerCase() === "disconnected") {
    this.signalConnection.start().catch();
  }
}

function UpdatePeoplesData() {
  this.peopleDetails.description = this.peopleDetails.description || "";
  this.peopleDetails.history = this.peopleDetails.history || [];
  this.profileData = _.cloneDeep(this.peopleDetails);
  this.historyData = this.profileData.history || [];
  this.description = this.profileData.description || "";
}
async function onclose() {
  this.overlay = false;

  switch (this.$route.params.origin) {
    case "dashboard":
      this.$router.push("/dashboard");
      break;
    case "people":
      this.$router.push("/people");
      break;
    case "search":
      this.$router.push("/search");
      break;
    default:
      this.$router.push("/");
      break;
  }
}

async function saveOnLeave({ next }) {
  if (this.$refs.form.validate()) {
    await this.updatePeopleProfileOnLeave()
      .then((res) => {
        next();
      })
      .catch((error) => {
        this.showMessageSheet(this.$t("msgProfileError"), "error");
      });
  }
}

async function updatePeopleProfile() {
  if (this.$refs.form.validate()) {
    let profilInfo = _.cloneDeep(this.profileData);

    let formData = new FormData();
    if (!profilInfo.profilePhoto) {
      formData.append("profilePhoto", ""); // append files or other data
    } else {
      const existingPhoto = base64ToFile(profilInfo.profilePhoto);
      formData.append("profilePhoto", existingPhoto); // append files or other data
    }

    delete profilInfo.profilePhoto;
    formData.append("userData", JSON.stringify(profilInfo));

    await this.updatePeople(formData)
      .then((res) => {
        this.isPhotoUpdated = false;
        this.showMessageSheet(this.$t("msgProfileSuccess"), "success");
      })
      .catch((error) => {
        console.error(error);
      });
  }
}

async function updatePeopleProfileOnLeave() {
  if (this.$refs.form.validate()) {
    let profilInfo = _.cloneDeep(this.profileData);

    let formData = new FormData();
    if (!profilInfo.profilePhoto) {
      formData.append("profilePhoto", ""); // append files or other data
    } else {
      const existingPhoto = base64ToFile(profilInfo.profilePhoto);
      formData.append("profilePhoto", existingPhoto); // append files or other data
    }

    delete profilInfo.profilePhoto;
    formData.append("userData", JSON.stringify(profilInfo));

    await this.updatePeople(formData)
      .then((res) => {
        this.isPhotoUpdated = false;
        //this.showMessageSheet(this.$t("msgProfileSuccess"), "success");
      })
      .catch((error) => {
        console.log(error, "api error");
        //this.showMessageSheet(this.$t("msgProfileError"), "error");
      });
  }
}

async function mounted() {
  try {
    this.isDataLoading = true;
    await this.getTenantConfigList().catch((e) => {
      this.loading = false;
      this.isDataLoading = false;
    });
    // this.skillList = this.tenantSettingTypes("skills");
    const result = await this.$refs.refSwitchDialog.checkTenantName();
    if (!result) {
      if (this.$route.params.id) {
        await this.getPeopleById(this.$route.params.id)
          .then((res) => {
            this.UpdatePeoplesData();
          })
          .catch((e) => {
            this.isDataLoading = false;
            this.showMessageSheet(e.message, "error");
            this.waitOnMessage();
          });
      }
      this.signalRInit(`peoples_${this.selectedTenant}`);
      this.signalRConfigInit(`tenant_config_${this.selectedTenant}`);
      this.isDataLoading = false;
    }
  } catch (error) {
    console.log(error, "api error");
  }
}

async function signalRConfigInit(target) {
  await this.signalConnection.on(target, async (message) => {
    const config_name = message.config_name || "";
    if (config_name === "skills") {
      await this.getTenantConfigList();
    }
  });
  if (this.signalConnection.connectionState.toLowerCase() === "disconnected") {
    this.signalConnection.start().catch();
  }
}

function waitOnMessage() {
  if (this.displayMessage) {
    this.wait(100).then((res) => {
      this.waitOnMessage();
    });
  } else {
    // CODE to launch until condition is met
    this.onclose();
  }
}

async function filesChange(fileList) {
  const files = fileList;
  let filesWithStatus = [];
  if (files.length == 0) {
    return false;
  }

  for (let item of files) {
    if (!["image/png", "image/jpeg", "image/gif"].includes(item.type)) {
      filesWithStatus.push(this.$t("fileErrorMsg", { filename: item.name }));
    } else if (item.size > this.maxProfileImgSize) {
      filesWithStatus.push(
        this.$t("fileSizeErrorMsg", {
          maxsize: formatBytes(this.maxProfileImgSize),
        })
      );
    }
  }
  if (filesWithStatus.length > 0) {
    this.showMessageSheet(filesWithStatus.join("/n"), "error");
    return false;
  }
  this.isPhotoUpload = false;
  this.overlay = true;
  const fileReader = new FileReader();
  fileReader.addEventListener("load", async () => {
    await wait(1500);
    this.profileData.profilePhoto = fileReader.result;
    this.isPhotoUpload = true;
    this.isPhotoUpdated = true;
  });
  fileReader.readAsDataURL(files[0]);
}

async function wait(ms) {
  let promise = new Promise((res, rej) => {
    setTimeout(() => res("Now it's done!"), ms);
  });

  await promise;
}

function filterKey(event) {
  const regex = /^[a-zA-Z0-9&()]*$/;

  // Allow the backspace key (keyCode 8) and delete key (keyCode 46)
  if (event.keyCode === 8 || event.keyCode === 32 || event.keyCode === 46) {
    return;
  }
   
  if (!regex.test(event.key)) {
    event.preventDefault();
  }
}
</script>

<style scoped>
#autocomplete-skills /deep/ .v-input__control,
#autocomplete-skills /deep/ .v-input__slot {
  max-height: 110px !important;
}
#autocomplete-skills /deep/ .v-select__selections {
  max-height: 100px !important;
}
#autocomplete-skills /deep/ .v-select__slot {
  max-height: 110px !important;
  overflow-y: auto !important;
  overflow-x: hidden !important;
}
/* .v-avatar.profile {
  transition: opacity .4s ease-in-out;
}
.v-avatar.profile:not(.on-hover) {
  opacity: 0.1;
 } */

.selectField /deep/ .v-select__selection {
  line-height: 21px !important;
}
.profile {
  overflow: auto;
}

.show-btns {
  color: red !important;
  display: none;
  opacity: 1;
  z-index: 9999;
}

.textField {
  font-family: "Noto Sans JP" !important;
  font-style: normal !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  line-height: 18px !important;
  min-height: 48px !important;
  max-height: 68px !important;
  color: var(--v-neutralGray-base) !important;
  align-items: center !important;
  border-radius: 0 !important;
}

.textField > .v-input__control > .v-input__slot {
  color: var(--v-neutralGray-base) !important;
  height: 48px !important;
}

.textField /deep/ .v-input__control {
  border-radius: 0 !important;
}

.textField > .v-input__control > .v-input__slot > .v-text-field__slot {
  color: var(--v-neutralGray-base) !important;
}

.textField /deep/ .v-label {
  color: var(--v-neutralGray-base) !important;
  font-size: 16px !important;
}

.textField .v-input__prepend-outer {
  align-self: flex-start !important;
}

::v-deep .e-richtexteditor .e-rte-toolbar,
.e-richtexteditor .e-rte-toolbar.e-toolbar.e-extended-toolbar {
  z-index: 0 !important;
}
</style>